import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllConnections } from '../../apis/Connections';

// Thunk: always fetch fresh list
export const fetchConnections = createAsyncThunk(
  'connections/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchAllConnections(); // returns [] on failure inside
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch connections');
    }
  }
);

const connectionsSlice = createSlice({
  name: 'connections',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetConnections: (state) => {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConnections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConnections.fulfilled, (state, action) => {
        state.items = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false;
      })
      .addCase(fetchConnections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Unknown error';
      });
  },
});

export const { resetConnections } = connectionsSlice.actions;

// Selectors
export const selectConnections = (state) => state.connections.items;
export const selectConnectionsCount = (state) => state.connections.items.length;
export const selectConnectionsLoading = (state) => state.connections.loading;
export const selectConnectionsError = (state) => state.connections.error;

export default connectionsSlice.reducer;
